import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
/* Shell styles are imported by pages/Main (lazy) — see below. */
/* (moved to pages/Main) */
/* (moved to pages/Main) */
import { ToastContainer } from 'react-toastify';


const container = document.getElementById("root");
const root = createRoot(container);

root.render(<>
    <App />
    <ToastContainer />
</>);
